query ChartTypes {
  chartTypes(orderBy: ID_ASC) {
    nodes {
      id
      caption
    }
  }
}